import React, { Fragment, useState } from "react"
import { GenericDialog } from "../../../generic/GenericDialog"
import { LoginForm } from "./LoginForm";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { SendResetPasswordForm } from "./SendResetPasswordForm";
import { ResetPasswordForm } from "./ResetPasswordForm";
import { PasswordChanged } from "./PasswordChanged";
import { ProfileSetupDialog } from "../../profileSetup/ProfileSetupDialog";
import { BASIC_INFO_KEY } from "../../../../enums/profileSetupEnums";
import { useLogoutUser } from "../../../generic/functions/genericFunctions";
import { Verification } from "../signup/Verification";
import { AccountExists } from "./AccountExists";
import { AccountBanned } from "./AccountBanned";

export const LoginDialog = (props) => {
  const {
    selectedForm,
    setSelectedForm,
    openLoginDialog,
    handleCloseDialog,
    handleOpenSignUpDialog,
    handleOpenLoginDialog
  } = props;

  const handleLogout = useLogoutUser();
  const [userDetails, setUserDetails] = useState();
  const [selectedSetupForm, setSelectedSetupForm] = useState(BASIC_INFO_KEY);
  const [openProfileSetupDialog, setOpenProfileSetupDialog] = useState(false);

  const handleCloseProfileSetupDialog = () => {
    setOpenProfileSetupDialog(false);
    setUserDetails();
    handleLogout();
  };

  const handleNextForm = (data) => {
    setSelectedForm(data);
  };

  const forms = {
    'login': <LoginForm
      handleOpenSignUpDialog={handleOpenSignUpDialog}
      handleNextForm={handleNextForm}
      handleCloseDialog={handleCloseDialog}
      setOpenProfileSetupDialog={setOpenProfileSetupDialog}
      setUserDetails={setUserDetails}
    />,
    'forgot-password': <ForgotPasswordForm handleNextForm={handleNextForm} handleOpenLoginDialog={handleOpenLoginDialog} />,
    'send-reset-password': <SendResetPasswordForm email={userDetails?.email}/>,
    'reset-password': <ResetPasswordForm handleNextForm={handleNextForm} />,
    'password-changed': <PasswordChanged handleOpenLoginDialog={handleOpenLoginDialog} />,
    'account-exists': <AccountExists handleCancel={handleCloseDialog} email={selectedForm?.data?.email} handleNextForm={handleNextForm} />,
    'verify-email': <Verification email={selectedForm?.data?.email} />,
    'account-banned': <AccountBanned />,
  };

  return (
    <Fragment>
      <GenericDialog
        openDialog={openLoginDialog}
        handleClose={() => handleCloseDialog()}
        title={selectedForm?.title}
        showClose={selectedForm?.showClose}
        width={selectedForm?.width}
      >
        {forms?.[selectedForm?.key]}
      </GenericDialog>
      <ProfileSetupDialog
        selectedSetupForm={selectedSetupForm}
        openProfileSetupDialog={openProfileSetupDialog}
        handleCloseProfileSetupDialog={handleCloseProfileSetupDialog}
        userDetails={userDetails}
        setSelectedSetupForm={setSelectedSetupForm}
      />
    </Fragment>
  )
}